import { Component, OnInit } from '@angular/core';
import {ICellEditorAngularComp} from 'ag-grid-angular';

@Component({
  selector: 'app-cell-editor-asm-tags',
  templateUrl: './cell-editor-asm-tags.component.html',
  styleUrls: ['./cell-editor-asm-tags.component.scss']
})
export class CellEditorAsmTagsComponent implements ICellEditorAngularComp, OnInit {
  public params: any;

  public items: any = [];
  public newTagValue: string = '';
  public tags: any = [
    {value: 'dimensions', viewValue: 'Dimensions'},
    {value: 'multi-box-dimensions', viewValue: 'Multi box dimensions'},
    {value: 'free-shipping', viewValue: 'Free shipping'},
    {value: 'free-ship-method', viewValue: 'Free ship method'},
    {value: 'ship-alone', viewValue: 'Ship alone'},
    {value: 'flat-ship-rates', viewValue: 'Flat ship rates'},
    {value: 'origin-zip', viewValue: 'Origin ZIP'},
    {value: 'number-of-boxes', viewValue: 'Number of boxes'},
    {value: 'multi-box-weights', viewValue: 'Multi box weights'},
    {value: 'invalid-ship-methods', viewValue: 'Invalid ship methods'},
    {value: 'markup', viewValue: 'Markup'},
    {value: 'global-free-ship-exclusion', viewValue: 'Global free ship exclusion'},
    {value: 'exclude-states', viewValue: 'Exclude states'},
    {value: 'exclude-countries', viewValue: 'Exclude countries'},
  ];

  public newTag: string = '';
  public updateAction: boolean = false;

  private allowSave: boolean = false;

  constructor() {
    this.tags.sort((a: any, b: any) => a.value.localeCompare(b.value));
    console.log('this.tags', this.tags);
  }

  ngOnInit(): void {}

  agInit(params: any): void {
    this.params = params;
    if (this.params.data?.asm_tags?.length) {
      this.items = this.params.data.asm_tags.split(',');
    }
  }

  tagSelectorOnChange($event: any) {
    this.newTag = $event.value;
    const existTag = this.items.findIndex((i: any) => i.split(':')[0] === this.newTag);
    if (existTag !== -1) {
      this.updateAction = true;
      this.newTagValue = this.items[existTag].split(':')[1];
    } else {
      this.updateAction = false;
      this.newTagValue = '';
    }
  }

  getValue(): any {
    if (this.allowSave) {
      return this.items.join(', ');
    } else {
      return this.params.data.asm_tags;
    }
  }

  deleteTag(item: any) {
    const itemIndex = this.items.findIndex((i: any) => i.split(':')[0] === item.split(':')[0]);
    if (itemIndex === -1) {
      this.updateAction = false;
    }
  }

  updateTag() {
    const itemIndex = this.items.findIndex((i: any) => i.split(':')[0] === this.newTag);
    if (itemIndex !== -1) {
      this.items[itemIndex] = this.items[itemIndex].split(':')[0] + ':' + this.newTagValue;
    }
  }

  addTag() {
    this.items.push(this.newTag + ':' + this.newTagValue);
    this.newTag = '';
    this.newTagValue = '';
  }

  close() {
    this.params.stopEditing();
  }

  save() {
    this.allowSave = true;
    this.params.stopEditing();
  }

  tagOnClick(item: any): void {
    console.log('tagOnClick', item);
    this.updateAction = true;
    this.newTag = item.split(':')[0];
    this.newTagValue = item.split(':')[1];
  }

  remove(item: any): void {
    const index = this.items.indexOf(item);

    if (index >= 0) {
      this.items.splice(index, 1);
    }
  }
}
